import { Component, Input } from "@angular/core"
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"

@Component({
    selector: "app-assign-modal",
    templateUrl: "./assign-modal.component.html",
    styleUrls: ["./assign-modal.component.less"],
})
export class AssignModalComponent {
    @Input() public activityData: any = null

    constructor(public activeModal: NgbActiveModal) {}
}
